var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "settings__section" }, [
    _c("div", { staticClass: "settings__container" }, [
      _vm._m(0),
      _c("div", { staticClass: "publicDetails__section" }, [
        _c(
          "a",
          {
            staticClass: "btn btn--purpleLight",
            attrs: { href: _vm.updateUrl }
          },
          [_vm._v("Update Payment Method")]
        ),
        _c(
          "a",
          {
            staticClass: "btn btn--purpleLight",
            attrs: { href: _vm.cancelUrl }
          },
          [_vm._v("Cancel Subscription")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "settings__flixelPlan" }, [
      _c("div", { staticClass: "settings__flixelPlan--header" }, [
        _c("div", { staticClass: "settings__flixelPlan--title" }, [
          _c("h1", [_vm._v("Manage Subscription")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bdec562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdec562","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ManageSettings.vue
// module id = null
// module chunks = 